module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-500.f5b74d7.woff2";